/**
 * Prediction markets config — add one object to surface a new instrument.
 * V1: Gold + Silver only.
 */
export type MarketStatus = 'Live' | 'Coming Soon'

export type MarketConfig = {
  id: string
  name: string
  symbol: string
  status: MarketStatus
  description: string
  strategies: readonly string[]
}

export const MARKETS: MarketConfig[] = [
  {
    id: 'gold',
    name: 'Gold',
    symbol: 'XAU/USD',
    status: 'Live',
    description: 'Structured prediction trading on Gold with predefined strategy models.',
    strategies: ['SAFE', 'BALANCE', 'AGGRESSIVE'],
  },
  {
    id: 'silver',
    name: 'Silver',
    symbol: 'XAG/USD',
    status: 'Live',
    description: 'Structured prediction trading on Silver with predefined strategy models.',
    strategies: ['SAFE', 'BALANCE', 'AGGRESSIVE'],
  },
]

export const DEFAULT_MARKET_ID = 'gold'

export function getLiveMarkets(): MarketConfig[] {
  return MARKETS.filter((m) => m.status === 'Live')
}

export function getMarketById(id: string): MarketConfig | undefined {
  return MARKETS.find((m) => m.id === id)
}

/* —— Compatibility aliases for Hero instrument selector —— */
export type PredictionInstrument = {
  id: string
  name: string
  symbol: string
  category: 'metals' | 'fx' | 'indices' | 'other'
  status: 'available' | 'coming_soon'
  blurb: string
  ctaLabel: string
  strategies: readonly string[]
}

export const AVAILABLE_INSTRUMENTS: PredictionInstrument[] = MARKETS.map((m) => ({
  id: m.id,
  name: m.name,
  symbol: m.symbol,
  category: 'metals',
  status: m.status === 'Live' ? 'available' : 'coming_soon',
  blurb: m.description,
  ctaLabel: 'View Market',
  strategies: m.strategies.map((s) => `${s} Strategy`),
}))

export const DEFAULT_INSTRUMENT_ID = DEFAULT_MARKET_ID

export function getAvailableInstruments(): PredictionInstrument[] {
  return AVAILABLE_INSTRUMENTS.filter((i) => i.status === 'available')
}

export function getInstrumentById(id: string): PredictionInstrument | undefined {
  return AVAILABLE_INSTRUMENTS.find((i) => i.id === id)
}
